import { Injectable } from "@angular/core";
import { createFunctionResult, FUNCTION_RESULT_STATUS, FunctionResult, IObjectKey, IPlatformUser } from "@nova/common-interfaces";
import { FUNCTION_NAME } from "@rfm/shared-interfaces";
import { httpsCallable } from "firebase/functions";
import { CommonService } from "../../common/common.service.mjs";

@Injectable({ providedIn: "root" })
export class PlatformUserService extends CommonService<
  IPlatformUser,
  IObjectKey
> {
  protected override deleteFunctionName: FUNCTION_NAME =
  FUNCTION_NAME.PLATFORM_USER_REMOVE;
  
  // #region Properties (6)

  protected override getAllFunctionName: FUNCTION_NAME =
    FUNCTION_NAME.PLATFORM_USER_GETALL;
    protected override getFunctionName: FUNCTION_NAME =
    FUNCTION_NAME.PLATFORM_USER_GET;
    protected override getKeysFunctionName: FUNCTION_NAME =
    FUNCTION_NAME.PLATFORM_USER_GETKEYS;
    protected override insertFunctionName: FUNCTION_NAME =
    FUNCTION_NAME.PLATFORM_USER_INSERT;
    protected override mergeFunctionName: FUNCTION_NAME =
    FUNCTION_NAME.PLATFORM_USER_MERGE;
    protected override updateFunctionName: FUNCTION_NAME =
    FUNCTION_NAME.PLATFORM_USER_UPDATE;
    protected  passwordResetFunctionName: FUNCTION_NAME =
    FUNCTION_NAME.PLATFORM_USER_RESETLINK;

  // #endregion Properties (6)

  // #region Public Methods (1)


  public async resetPasswordLink(email: string): Promise<FunctionResult<string>> {

    return new Promise<FunctionResult<string>>((resolve, reject) => {
      const callable = httpsCallable<string, FunctionResult<string>>(
        this.functions,
        this.passwordResetFunctionName.toString()
      );
      callable(email)
        .then(
          (result) => {
            return resolve(result.data);
          },
          (error) => {
            console.error(error);
            return reject(createFunctionResult<string>(FUNCTION_RESULT_STATUS.ERROR, ""));
          }
        )
        .finally(() => {
        });
    });
  }


  public async refresh(): Promise<boolean> {
    return Promise.resolve(true);
  }

  // #endregion Public Methods (1)
}
